
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import CreateSection from "./create/CreateSection";
import DiscussionSection from "./discussion/DiscussionSection";
import SearchSection from "./search/SearchSection";

export default function DiscussionList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'تالار', href: '/discussion_list/' },
	];
	const [searchParams, setSearchParams] = useSearchParams();
	const queryParam = searchParams.get('query');

	function onSearch(newQuery) {
		if (newQuery === queryParam) {
			return;
		}
		navigate(`/discussion_list/?query=${newQuery ? newQuery : ''}`);
	}

	return (
		<>
			<Helmet>
				<title>تالار گفتگو | همراهتیم</title>
				<meta name="description" content="فهرست گفتگوهای همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[50px]"></div>
					<div className={`${isDesktop ? 'w-[1200px]' : 'p-[10px]'} mx-auto`}>
						<CreateSection />
						<div className="spacer p-[20px]"></div>
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<div className="spacer p-[10px]"></div>
						<DiscussionSection isDesktop={isDesktop} query={queryParam} />
					</div>
					<div className="spacer p-[50px]"></div>
				</div>
				<div>
					<Footer isDesktop={isDesktop} activeButton={FooterButton.DISCUSSIONS} />
				</div>
			</div>
		</>
	)
}
